import { NoteDetailFormValue } from '../../../../../coaching-note/note-detail-form-value.model';
export function sortNotesByCreatedOnDesc(
    notes: NoteDetailFormValue[],
): NoteDetailFormValue[] {
    return notes.sort((a, b) => {
        const dateA = new Date(a.trackingOriginal.createdOn);
        const dateB = new Date(b.trackingOriginal.createdOn);

        return dateB.getTime() - dateA.getTime();
    });
}
